import { Fancybox } from "@fancyapps/ui";

function fancyBoxModal() {


    Fancybox.bind("[data-fancybox='video-gallery']", {
        //selector : '.swiper-slide:not(.swiper-slide-duplicate)',
        Thumbs: {
            autoStart: false,
            axis: 'x'
        },
        Carousel: {
            Navigation: false,
            //touch:false,
            'infinite': false,
        },
    })

}
export default fancyBoxModal;